<div
    class="auth-screen-wrapper flex min-w-0 flex-auto flex-col items-center sm:flex-row sm:justify-center md:items-start md:justify-start add-padding"
>
    <div
        class="auth-left-side-image-box relative hidden h-full w-1/2 flex-auto items-center justify-center  overflow-hidden p-16 dark:border-l md:flex lg:px-28 img-bg card-left-side-radius"
    >
                <div class="auth-left-side-image relative z-10 w-full max-w-2xl">
                    <img src="grimmorLogo.svg" class="scale-[2]" alt="logo"/>
                </div>
    </div>
    <div class="auth-right-side-content w-full px-4 py-8 sm:bg-card sm:w-auto sm:p-12 sm:shadow md:flex md:h-full md:w-1/2 md:items-center justify-center md:p-16 md:shadow-none card-right-side-radius">
        <div class="auth-content-inner mx-auto w-full max-w-80 sm:mx-0 sm:w-80">
            <!-- Logo -->
            <div class="w-50">
            </div>

            <!-- Title -->
            <div
                class="xxl:mt-8 text-4xl font-extrabold leading-tight tracking-tight"
            >
                {{LABELS.RESET_PASSWORD}}
<!--                <img src="grimmor-image.png" class="img-wrapper"/>-->
            </div>
            <!-- Sign in form -->
            <form
                #resetPasswordNgForm="ngForm"
                [formGroup]="resetPasswordForm"
                class="mt-8"
            >   
                @if(!emailFromUrl){
                <mat-form-field class="w-full " floatLabel="always">
                    <mat-label>{{LABELS.VERIFICATION_CODE}}</mat-label>
                    <input
                        #otp
                        [formControlName]="'otp'"
                        [placeholder]="LABELS.ENTER_VERIFICATION_CODE"
                        id="otp"
                        matInput
                        type="test"
                        (paste)="checkNumber($event,otp)"
                        maxlength="4" name="otp" onkeypress="return (event.charCode === 8 || event.charCode === 0 || event.charCode === 13) ? null : event.charCode >= 48 && event.charCode <= 57"
                    />
                    @if (resetPasswordForm.get('otp').hasError('required')) {
                        <mat-error>
                            {{LABELS.OTP_REQUIRED}}
                        </mat-error>
                    }@if (resetPasswordForm.get('otp').hasError('pattern')) {
                        <mat-error>
                           {{LABELS.FOUR_DIGIT_OTP_REQUIRED}}
                        </mat-error>
                    }
                </mat-form-field>
                <div class="show-timer">
                    @if(hideResendBtn){
                        <div class="timer" style="display: flex; gap: 3px;">
                            <img src="Clock.svg" class="w-4" alt="logo"/>
                            <span>{{transform(seconds)}}</span></div>
                    }
                    @else{
                        <div class="timer-bttn" [ngClass]="isSendOtp?'disabled-send-otp':''" ><button (click)="resendOTP()" [disabled]="isSendOtp" type="button">Resend OTP</button></div>
                    }
                </div>
                }
                <!-- <mat-form-field class="w-full" floatLabel="always">
                    <mat-label>{{LABELS.NEW_PASSWORD}}</mat-label>
                    <input
                        #passwordField
                        [formControlName]="'password'"
                        id="password"
                        matInput
                        type="password"
                        [placeholder]="LABELS.ENTER_NEW_PASSWORD"
                    />
                    <button
                        (click)="
                            passwordField.type === 'password'
                                ? (passwordField.type = 'text')
                                : (passwordField.type = 'password')
                        "
                        mat-icon-button
                        matSuffix
                        type="button"
                    >
                        @if (passwordField.type === 'password') {
                            <mat-icon
                                class="icon-size-5"
                                [svgIcon]="'heroicons_solid:eye'"
                            ></mat-icon>
                        }
                        @if (passwordField.type === 'text') {
                            <mat-icon
                                class="icon-size-5"
                                [svgIcon]="'heroicons_solid:eye-slash'"
                            ></mat-icon>
                        }
                    </button>
                    <mat-error> {{LABELS.PASSWORD_REQUIRED}} </mat-error>
                </mat-form-field> -->
                <mat-form-field class="w-full" floatLabel="always">
  <mat-label>{{LABELS.NEW_PASSWORD}}</mat-label>
  <input
    #passwordField
    formControlName="password"
    id="password"
    matInput
    type="password"
    [placeholder]="LABELS.ENTER_NEW_PASSWORD"
  />
  <button
    (click)="passwordField.type === 'password' ? (passwordField.type = 'text') : (passwordField.type = 'password')"
    mat-icon-button
    matSuffix
    type="button"
  >
    @if (passwordField.type === 'password') {
      <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:eye'"></mat-icon>
    }
    @if (passwordField.type === 'text') {
      <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:eye-slash'"></mat-icon>
    }
  </button>

  @if (resetPasswordForm.get('password')?.hasError('required')) {
    <mat-error> {{LABELS.PASSWORD_REQUIRED}} </mat-error>
  }
  @else if (resetPasswordForm.get('password')?.hasError('minlength')) {
    <mat-error> Password must be at least 8 characters long</mat-error>
  }
   @else if (resetPasswordForm.get('password')?.hasError('pattern')) {
    <mat-error>Password must include uppercase, lowercase, number, and special character</mat-error>
  }
</mat-form-field>


                <mat-form-field class="w-full mt-5" floatLabel="always">
                    <mat-label>{{LABELS.CONFIRM_PASSWORD}}</mat-label>
                    <input
                        #passwordConfirmField
                        [formControlName]="'passwordConfirm'"
                        id="password-confirm"
                        matInput
                        type="password"
                        [placeholder]="LABELS.ENTER_CONFIRM_PASSWORD"
                    />
                    <button
                        (click)="
                            passwordConfirmField.type === 'password'
                                ? (passwordConfirmField.type = 'text')
                                : (passwordConfirmField.type = 'password')
                        "
                        mat-icon-button
                        matSuffix
                        type="button"
                    >
                        @if (passwordConfirmField.type === 'password') {
                            <mat-icon
                                class="icon-size-5"
                                [svgIcon]="'heroicons_solid:eye'"
                            ></mat-icon>
                        }
                        @if (passwordConfirmField.type === 'text') {
                            <mat-icon
                                class="icon-size-5"
                                [svgIcon]="'heroicons_solid:eye-slash'"
                            ></mat-icon>
                        }
                    </button>
                    @if (
                        resetPasswordForm
                            .get('passwordConfirm')
                            .hasError('required')
                        ) {
                        <mat-error>
                            {{LABELS.CONFIRM_PASSWORD_REQUIRED}}
                        </mat-error>
                    }
                    @if (
                        resetPasswordForm
                            .get('passwordConfirm')
                            .hasError('mustMatch')
                        ) {
                        <mat-error> {{LABELS.PASSWORD_NOT_MATCH}}</mat-error>
                    }
                </mat-form-field>

                <button
                    (click)="resetPassword()"
                    [disabled]="resetPasswordForm.disabled"
                    class="fuse-mat-button-large mt-3 w-full btn-theme-color"
                    mat-flat-button
                >
                    @if (!resetPasswordForm.disabled) {
                        <span>  {{isSetPassword ? LABELS.SET_PASSWORD : LABELS.RESET_PASSWORD}} </span>
                    }
                    @if (resetPasswordForm.disabled) {
                        <mat-progress-spinner
                            [diameter]="24"
                            [mode]="'indeterminate'"
                        ></mat-progress-spinner>
                    }
                </button>

                <div class="mt-8 text-md font-medium flex justify-end">
                    <a
                        [routerLink]="[_router.url.indexOf('/partner/') !== -1 ? '/partner':'/']"
                        class="ml-1 theme-color hover:underline"
                    >{{LABELS.RETURN_TO}} {{LABELS.SING_IN}}
                    </a>
                </div>
            </form>
        </div>
    </div>
</div>

